import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=20d220bb&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d220bb')) {
      api.createRecord('20d220bb', component.options)
    } else {
      api.reload('20d220bb', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=20d220bb&", function () {
      api.rerender('20d220bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/comp/ErrorMessage.vue"
export default component.exports